import type { SVGProps } from 'react'
const SvgAlbumPageFilled = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill={props.color ?? 'currentColor'}
        viewBox="0 0 24 24"
        {...props}>
        <path
            fill={props.color ?? 'currentColor'}
            d="M13 17.05c.733-.35 1.47-.613 2.213-.788a10.268 10.268 0 0 1 4.05-.113c.575.101 1.154.251 1.737.451V6.7a8.664 8.664 0 0 0-1.712-.525 9.218 9.218 0 0 0-4.113.125c-.767.2-1.492.5-2.175.9zm-1 2.425c-.233 0-.454-.03-.662-.088a2.796 2.796 0 0 1-.588-.237 8.182 8.182 0 0 0-2.05-.862A8.477 8.477 0 0 0 6.5 18c-.7 0-1.388.092-2.062.275a9.05 9.05 0 0 0-1.938.775c-.35.183-.687.175-1.012-.025A.966.966 0 0 1 1 18.15V6.1c0-.183.046-.358.137-.525A.863.863 0 0 1 1.55 5.2c.783-.383 1.588-.68 2.412-.888C4.788 4.105 5.634 4 6.5 4A10.78 10.78 0 0 1 12 5.5 10.78 10.78 0 0 1 17.5 4c.867 0 1.712.104 2.538.313.825.208 1.629.504 2.412.887.183.083.32.208.413.375.091.167.137.342.137.525v12.05a.966.966 0 0 1-.488.875c-.325.2-.662.208-1.012.025a9.05 9.05 0 0 0-1.937-.775A7.836 7.836 0 0 0 17.5 18c-.75 0-1.483.096-2.2.288-.717.191-1.4.479-2.05.862-.183.1-.38.18-.588.238-.208.058-.429.087-.662.087"
        />
    </svg>
)
export default SvgAlbumPageFilled
